import { createReducer, on } from "@ngrx/store";
import { ADD_CURRENCY } from "../actions/currency.action";
import { BogCurrencyInformationModel } from "../models/currency.model";
const INITIAL_STATE: BogCurrencyInformationModel = {} as BogCurrencyInformationModel; 

export const CurrencyReducer = createReducer(
  INITIAL_STATE,
  on(ADD_CURRENCY, (_, { currency }) => currency),
);
